module.exports = __webpack_public_path__ + "media/images/signature_example-afe100f91acdb776e3795d0364a6da76.jpg";